import { useState } from "react";

export default function Pagination({
  Total_Records,
  PaginationTable,
  SetPaginate_Page,
  UniversityTable_Set,
}) {
  const records = Math.ceil(Total_Records / PaginationTable);
  const arr = Array.from({ length: records }, (_, index) => index + 1);
  const [activePage, setActivePage] = useState(1);
  const handlePage = (Page_No) => {
    let page;
    if (Page_No) {
      page = activePage + Page_No;
    } else {
      page = 1;
    }

    if (page >= 1 && page <= Math.ceil(Total_Records / PaginationTable)) {
      setActivePage(page);
      SetPaginate_Page(page);
    }
  };

  const handleSinglePage = (page) => {
    setActivePage(page);
    SetPaginate_Page(page);
  };

  return (
    <div className="table-page-details">
      <div className="row">
        <div className="col-md-9">
          <div className="page-number">
            <ul className="pagination justify-content-center">
              <li className="page-item" onClick={() => handlePage(-1)}>
                <button
                  disabled={activePage === 1}
                  className={
                    activePage === 1
                      ? "page-link deactive"
                      : "page-link button_color"
                  }
                  >
                  Previous
                </button>
              </li>
              {arr?.map((el, i) => (
                <li
                  onClick={() => handleSinglePage(+el)}
                  key={i}
                  className={
                    i <= activePage + 4 && i >= activePage - 3
                      ? "page-item"
                      : "page-item2"
                  }>
                  <a
                    className={
                      i === activePage - 1
                        ? "active_button page-link"
                        : "page-link"
                    }>
                    {el}
                  </a>
                </li>
              ))}
              <li className="page-item" onClick={() => handlePage(1)}>
                <button
                  disabled={
                    activePage === Math.ceil(Total_Records / PaginationTable)
                  }
                  className={
                    activePage === Math.ceil(Total_Records / PaginationTable)
                      ? "page-link deactive"
                      : "page-link button_color"
                  }
                  href="#">
                  Next
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-3 text-center">
          <div className="page-counter">
            <label>
              <select
                onChange={(e) => {
                  handlePage();
                  UniversityTable_Set(+e.target.value);
                }}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>{" "}
              of <span>{Total_Records}</span> records
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
